import { FlowModuleItemType } from "@packages/flow-core/module";
import { NodeProps } from "reactflow";
import NodeCard from "../NodeCard";
import Divider from "../Divider";
import styles from "./index.less";
import RenderInput from "../render/RenderInput";
import RenderOutput from "../render/RenderOutput";
import { ToolSourceHandle } from "../ToolHandle";
import { memo } from "react";

export default memo(function NodeTool({
  data,
  selected,
}: NodeProps<FlowModuleItemType>) {
  const { inputs, outputs, moduleId } = data;

  return (
    <NodeCard {...data} selected={selected}>
      <Divider text="输入" />
      <div className={styles.content}>
        <RenderInput moduleId={moduleId} flowInputList={inputs} />
      </div>
      <Divider text="输出" />
      <div className={styles.content}>
        <RenderOutput moduleId={moduleId} flowOutputList={outputs} />
      </div>
      <ToolSourceHandle moduleId={moduleId} />
      <Divider text="工具" />
    </NodeCard>
  );
});
